import { render, staticRenderFns } from "./Sbzc.vue?vue&type=template&id=4d65834d&scoped=true&"
import script from "./Sbzc.vue?vue&type=script&lang=js&"
export * from "./Sbzc.vue?vue&type=script&lang=js&"
import style0 from "./Sbzc.vue?vue&type=style&index=0&id=4d65834d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65834d",
  null
  
)

export default component.exports